<template>
  <b-card class="mb-2">
    <h4 class="mb-1">Subscription coupons</h4>
    <p class="text-muted mb-2">
      Codes discount the Growth (or Enterprise) monthly subscription. Charities enter a code when they register or when they change plan.
    </p>
    <b-row>
      <b-col md="3" class="mb-1">
        <label>Code</label>
        <b-form-input v-model="form.code" placeholder="GROWTH50" />
      </b-col>
      <b-col md="3" class="mb-1">
        <label>Label</label>
        <b-form-input v-model="form.label" placeholder="Launch offer" />
      </b-col>
      <b-col md="2" class="mb-1">
        <label>Percent off</label>
        <b-form-input v-model="form.percentOff" type="number" min="0" max="100" />
      </b-col>
      <b-col md="2" class="mb-1">
        <label>Amount off (CAD)</label>
        <b-form-input v-model="form.amountOff" type="number" min="0" />
      </b-col>
      <b-col md="2" class="mb-1">
        <label>Duration</label>
        <b-form-select v-model="form.duration" :options="durations" />
      </b-col>
      <b-col v-if="form.duration === 'repeating'" md="2" class="mb-1">
        <label>Months</label>
        <b-form-input v-model="form.durationInMonths" type="number" min="1" />
      </b-col>
      <b-col md="2" class="mb-1">
        <label>Max redemptions</label>
        <b-form-input v-model="form.maxRedemptions" type="number" min="0" placeholder="0 = unlimited" />
      </b-col>
      <b-col md="2" class="mb-1 d-flex align-items-end">
        <b-button variant="primary" :disabled="busy" @click="createCoupon">
          Create coupon
        </b-button>
      </b-col>
    </b-row>
    <b-alert v-if="error" show variant="danger" class="mt-1">{{ error }}</b-alert>
    <b-table
      class="mt-2"
      :items="items"
      :fields="fields"
      responsive
      small
      show-empty
      empty-text="No coupons yet"
    >
      <template #cell(discount)="data">
        <span v-if="data.item.percentOff">{{ data.item.percentOff }}%</span>
        <span v-else>{{ data.item.amountOff }} {{ data.item.currency || 'CAD' }}</span>
      </template>
      <template #cell(active)="data">
        <b-badge :variant="data.item.active ? 'success' : 'secondary'">
          {{ data.item.active ? 'Active' : 'Inactive' }}
        </b-badge>
      </template>
      <template #cell(actions)="data">
        <b-button
          v-if="data.item.active"
          size="sm"
          variant="outline-danger"
          @click="deactivate(data.item)"
        >
          Deactivate
        </b-button>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import API from './api'

export default {
  data() {
    return {
      busy: false,
      error: '',
      items: [],
      form: {
        code: '',
        label: '',
        percentOff: '',
        amountOff: '',
        duration: 'forever',
        durationInMonths: 3,
        maxRedemptions: 0,
      },
      durations: [
        { value: 'forever', text: 'Forever' },
        { value: 'once', text: 'First month' },
        { value: 'repeating', text: 'Repeating' },
      ],
      fields: [
        { key: 'code', label: 'Code' },
        { key: 'label', label: 'Label' },
        { key: 'discount', label: 'Discount' },
        { key: 'duration', label: 'Duration' },
        { key: 'timesRedeemed', label: 'Redeemed' },
        { key: 'active', label: 'Status' },
        { key: 'actions', label: '' },
      ],
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      API.listCoupons().then(res => {
        if (res.success) this.items = res.data || []
      }).catch(() => {})
    },
    createCoupon() {
      this.error = ''
      this.busy = true
      API.createCoupon({
        code: this.form.code,
        label: this.form.label,
        percentOff: Number(this.form.percentOff) || 0,
        amountOff: Number(this.form.amountOff) || 0,
        duration: this.form.duration,
        durationInMonths: Number(this.form.durationInMonths) || 0,
        maxRedemptions: Number(this.form.maxRedemptions) || 0,
        applicablePlans: ['growth'],
      }).then(res => {
        this.busy = false
        if (!res.success) {
          this.error = res.message || 'Could not create the coupon'
          return
        }
        this.form.code = ''
        this.form.label = ''
        this.form.percentOff = ''
        this.form.amountOff = ''
        this.load()
      }).catch(err => {
        this.busy = false
        this.error = err?.message || 'Could not create the coupon'
      })
    },
    deactivate(item) {
      API.deactivateCoupon(item.id).then(res => {
        if (!res.success) {
          this.error = res.message || 'Could not deactivate the coupon'
          return
        }
        this.load()
      }).catch(() => {})
    },
  },
}
</script>
